import vClickOutside from 'click-outside-vue3';

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    props: {
        content: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            isOpen: true,
            bodyHeight: 'auto',
            watchClassName: 'accordion',
        };
    },
    computed: {
        heightContent() {
            const height = this.isOpen ? this.bodyHeight : '0';
            return `max-height: ${height}px`;
        },
    },
    mounted() {
        this.setHeight();
    },
    methods: {
        setHeight() {
            this.bodyHeight = this.$refs.body.offsetHeight;
            this.isOpen = this.openBody;
        },
        toggleAccordion() {
            if (this.content.length) {
                event.preventDefault();// eslint-disable-line
                this.isOpen = !this.isOpen;
            }
        },
        // TODO: надо переделать, возможно без директивы
        onClickOutside(event) {
            if (!this.noClickOutside) {
                const { target } = event;
                setTimeout(() => {
                    if (target.className === this.watchClassName || target.closest(`.${this.watchClassName}`)) {
                        this.isOpen = false;
                    }
                }, 100);
            }
        }
    },
};
